var _rect, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconEquals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 16,
    viewBox: "0 0 30 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.5,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#8B60FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 12.5,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#8B60FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEquals);
export default __webpack_public_path__ + "static/media/icon-equals.9e7802dcdc03cd2d61a58567db5921ec.svg";
export { ForwardRef as ReactComponent };